<template>
  <div class="token-list-page">
    <div class="header">
      <h1 class="title">代币</h1>
    </div>

    <div class="loading" v-if="loading">
      <div class="loading-text">加载中...</div>
    </div>

    <div class="error" v-if="error && !loading">
      <div class="error-text">{{ error }}</div>
      <button class="retry-btn" @click="refreshData">重试</button>
    </div>

    <div class="token-list" v-if="!loading && !error">
      <div class="token-item">
        <div class="token-info">
          <div class="token-logo">
            <img src="../../views/images/index/gptd_logo.png" alt="GPTD">
          </div>
          <div class="token-details">
            <div class="token-symbol">GPTD</div>
            <div class="token-name">USDT</div>
          </div>
        </div>
        <div class="token-balance">
          <div class="balance-amount">{{ summary.totalGptd }}</div>
          <div class="balance-value">${{ summary.usdtValue }}</div>
        </div>
      </div>
    </div>

    <div class="rule-text">
      托管 500 USDT，每天可获取 1 枚 GPTD，最小单位 0.01，自动投放
    </div>
  </div>
</template>

<script>
import Fetch from '../../utils/fetch';
export default {
  name: 'TokenList',
  data() {
    return {
      summary: {
        totalGptd: '0.00',
        usdtValue: '0.00',
      },
      loading: false,
      error: null,
    }
  },
  mounted() {
    this.fetchTokenData()
  },
  methods: {
    fetchTokenData() {
      this.loading = true
      this.error = null

      Fetch('/index/gptd_log?page=1&pageSize=1').then((r) => {
        if (r.code === 1 && r.data) {
          const totalGptd = parseFloat(r.data.total_gptd || 0)
          this.summary = {
            totalGptd: totalGptd.toFixed(2),
            usdtValue: (totalGptd * 500).toFixed(2),
          }
        } else {
          this.error = r.info || '获取数据失败'
        }
        this.loading = false
      }).catch(() => {
        this.error = '网络请求失败'
        this.loading = false
      })
    },
    refreshData() {
      this.fetchTokenData()
    },
  }
}
</script>

<style scoped>
.token-list-page {
  background-color: #ffffff;
  min-height: 100vh;
}

.header {
  display: flex;
  align-items: center;
  padding: 20px 16px;
  border-bottom: 1px solid #f0f0f0;
}

.title {
  font-size: 18px;
  font-weight: 600;
  color: #333333;
  margin: 0;
}

.token-list {
  padding: 0 16px;
}

.token-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  border-bottom: 1px solid #f5f5f5;
}

.token-info {
  display: flex;
  align-items: center;
}

.token-logo {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 12px;
}

.token-logo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.token-symbol {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}

.token-name {
  font-size: 14px;
  color: #999999;
  margin-top: 2px;
}

.token-balance {
  text-align: right;
}

.balance-amount {
  font-size: 16px;
  font-weight: 600;
  color: #333333;
}

.balance-value {
  font-size: 14px;
  color: #999999;
  margin-top: 2px;
}

.rule-text {
  margin: 16px;
  padding: 12px;
  background: #fff8ef;
  border-radius: 8px;
  font-size: 12px;
  line-height: 1.6;
  color: #666;
}

.loading, .error {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 60px 16px;
}

.loading-text {
  font-size: 16px;
  color: #999999;
}

.error {
  flex-direction: column;
}

.error-text {
  font-size: 14px;
  color: #ff4444;
  margin-bottom: 12px;
}

.retry-btn {
  padding: 8px 16px;
  background-color: #ff5252;
  color: #ffffff;
  border: none;
  border-radius: 4px;
}
</style>
